import { Box, CircularProgress } from "@mui/material";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Text from "../../components/ui/Text";
import { useToast } from "../../contexts/ToastContext";
import apiService from "../../services/api";

const GeneratingTeams = () => {
  const { gameId } = useParams();
  const navigate = useNavigate();
  const { showToast } = useToast();

  useEffect(() => {
    if (!gameId) return;
    const generateTeams = async () => {
      try {
        const response = await apiService.generateTeams(gameId);
        if (response.success) {
          // showToast(response.message, "success");
          navigate(`/manage-teams/${gameId}`, {
            state: {
              count: response.count,
              data: response.data,
              max_players: response.max_players,
              spots_remaining: response.spots_remaining,
              team_summary: response.team_summary,
            },
          });
        }
      } catch (error) {
        showToast(error.error, "error");
      }
    };
    generateTeams();
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Text variant="pageHeader" sx={{ textAlign: "center" }}>
        Generating teams
      </Text>

      <Text
        variant="paragraph"
        sx={{
          textAlign: "center",
          color: "#525252",
          fontSize: "16px",
        }}
      >
        Creating two teams using the player list...
      </Text>

      <CircularProgress
        size={40}
        sx={{
          color: "#1890FF",
        }}
      />
    </Box>
  );
};

export default GeneratingTeams;
